import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useTranslation } from '@gem/modules/i18n';

import { UnauthorizedLayout } from 'APP/components/UnauthorizedLayout/UnauthorizedLayout';
import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';
import { useLoginByCode } from 'APP/pages/authorization/hooks/useLoginByCode';

import { useAuthorizationViewPresenter } from '../AuthorizationView/AuthorizationView.presenter';

export const AuthorizationView: FC = observer(() => {
  const { t } = useTranslation();
  const { isLoggingIn, code } = useLoginByCode();
  const presenter = useAuthorizationViewPresenter({ code });

  if (presenter.isAuthenticated) {
    return (
      <Navigate
        to={presenter.homePagePath}
        replace
      />
    );
  }

  return (
    <UnauthorizedLayout>
      {isLoggingIn ? (
        <UnauthorizedLayoutTemplate
          title={t('auth_sign_in')}
          isLoading
        />
      ) : (
        <Outlet />
      )}
    </UnauthorizedLayout>
  );
});
